import 'bootstrap/js/dist/collapse';
import 'slick-carousel';
import Swiper from 'swiper/bundle';

export default class ProductSingle {
    constructor() {
        console.info('ProductSingle');
        this.initListeners();

        const thumbSlider = new Swiper(".thumbnail-slider", {
            loop: true,
            spaceBetween: 10,
            slidesPerView: 4,
            watchSlidesProgress: true,
        });

        const gallerySlider = new Swiper(".gallery-slider", {
            loop: true,
            spaceBetween: 10,
            thumbs: {
                swiper: thumbSlider,
            },
            navigation: {
                nextEl: ".gallery-button-next",
                prevEl: ".gallery-button-prev",
            },
        });

        $('.surfaces-slider').slick({
            arrows: true,
            slidesToShow: 8,
            rows: false,
            infinite: false,
            prevArrow: "<button type='button' class='slick-prev'></button>",
            nextArrow: "<button type='button' class='slick-next'></button>",
            pagination: {
                el: ".swiper-pagination",
            },
            responsive: [
                {
                    breakpoint: 1600,
                    settings: {
                        slidesToShow: 8,
                    }
                },
                {
                    breakpoint: 1400,
                    settings: {
                        slidesToShow: 7,
                    }
                },
                {
                    breakpoint: 1200,
                    settings: {
                        slidesToShow: 6,
                    }
                },
                {
                    breakpoint: 992,
                    settings: {
                        slidesToShow: 4,
                    }
                },
                {
                    breakpoint: 768,
                    settings: {
                        slidesToShow: 3,
                    }
                },
                {
                    breakpoint: 440,
                    settings: {
                        slidesToShow: 2,
                    }
                },
            ]
        });

        this.centerSurfacesSlider();

        this.toggleCookiesMessage();

    }

    getCookie(cname) {
        const name = `${cname}=`;
        const decodedCookie = decodeURIComponent(document.cookie);
        const ca = decodedCookie.split(';');
        for(let i = 0; i < ca.length; i+=1) {
          let c = ca[i];
          while (c.charAt(0) === ' ') {
            c = c.substring(1);
          }
          if (c.indexOf(name) === 0) {
            return c.substring(name.length, c.length);
          }
        }
        return "";
    }

    toggleCookiesMessage() {
        const OptanonCookies = this.getCookie('OptanonConsent');
        Electro.functionalCookies = OptanonCookies.includes('C0003:1');

        document.querySelectorAll('.functional-cookies-disabled').forEach((el) => {
            if (!Electro.functionalCookies) {
                el.style.display = 'block';
                el.classList.remove('hidden');
            } else {
                el.style.display = 'none';
                el.classList.add('hidden');
            }
        });
        document.querySelectorAll('.functional-cookies-enabled').forEach((el) => {
            if (Electro.functionalCookies) {
                el.style.display = 'block';
                el.classList.remove('hidden');
            } else {
                el.style.display = 'none';
                el.classList.add('hidden');
            }
        });
    }

    centerSurfacesSlider() {
        const slideLength = $('.surfaces-slider').find('.slick-slide').length;
        if (slideLength >= 8) {
            $('.surfaces-slider').closest('.container-inner').addClass('wide');
        }
    }

    initListeners() {
        document.querySelectorAll('.product-scent-selector li').forEach((el) => {
            el.addEventListener('mouseover', () => {
                el.closest('.product-scent-selector').querySelector('.scent-name').innerHTML = el.querySelector('span').innerHTML;
            });
            el.addEventListener('mouseout', () => {
                el.closest('.product-scent-selector').querySelector('.scent-name').innerHTML = el.closest('.product-scent-selector').getAttribute('data-current');
            });
            el.querySelector('a').addEventListener('focus', () => {
                el.closest('.product-scent-selector').querySelector('.scent-name').innerHTML = el.querySelector('span').innerHTML;
            });
            el.querySelector('a').addEventListener('blur', () => {
                el.closest('.product-scent-selector').querySelector('.scent-name').innerHTML = el.closest('.product-scent-selector').getAttribute('data-current');
            });
        });

        document.addEventListener('click', (e) => {
            if (e.target.classList.contains('onetrust-close-btn-handler')) {
                setTimeout(() => {
                    this.toggleCookiesMessage();
                }, 1000);
            }
        });
    }
}
